import { Component, Input,inject,ViewChild, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal,NgbModalRef,NgbCalendar, NgbDateStruct,NgbDate } from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, FormControl,FormArray,Validators} from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Cookie } from 'ng2-cookies';
import * as saveFileAs from 'file-saver';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {SpinnerService} from '../../shared/services/spinner.service';
import {SwalAlertService} from '../../shared/services/swal-alert.service';
import {Subscription} from "rxjs";
import * as _ from 'lodash';
import {ToastNotificationService} from '../../shared/services/toast-notify.service';
import { ParentService } from './services/parent.service';
import { Parent } from '../../models/parent.model';
import { ParentDeleteComponent } from './parent.delete.component';
import { ParentEditComponent } from './parent.edit.component';
import { environment } from 'src/environments/environment';
import { SubscriptionComponent } from './subscription.component';
import { Feature } from 'src/app/models/feature.model';
import { ConfigService } from 'src/app/shared/services/config.service';
import { InventoryService } from '../inventory/services/inventory.service';
import { Student } from 'src/app/models/student.model';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { FeeStudent } from 'src/app/models/fee-student.model';
import { PaymentHistoryComponent } from '../fee/payment.history.component';
import { FeeService } from '../fee/services/fee.service';
import { RazorpayDto } from 'src/app/models/razorpay.model';
import { RazorpayService } from '../inventory/services/razorpay.service';
import { PayAmountComponent } from './payamount.component';
import { GlobalConstants } from 'src/app/shared/util/global.constant';

@Component({
  selector: 'app-parent',
  templateUrl: './fee.component.html',
  styleUrls: ['./parent.component.scss'],
  
})
export class FeeComponent implements OnInit {
  title = 'Fee';
  modalRef: NgbModalRef;  
	dateModel: NgbDateStruct;
  styleString = '';
  searchForm: FormGroup;

  masterSelected:boolean;
  checkedList:Parent[]= [];

  studentList: Student[];
  sessionList: string[];
  feeList: FeeStudent[];
  userRole: string;
  loggedinUser: string;

  showRefreshSpinner: boolean;
  
  page: any;  // for pagination response data 
  currentPageData: Parent[] ;
  searchTerm: string;
  querySub: Subscription;
  totalItemCount: number;
  itemPerPage: number;
  size: number = environment.defaultPaginationSize; //10
  //itemPerPageDefault: number = 5;

  // for Sorting
	sortFlag: boolean = true;
	arrowIcon: any;
	cName: any;

  countryList: any[];
  /*******************show/hide columns**************************/
  
  constructor(
      private http: HttpClient,private formBuilder: FormBuilder,private configService: ConfigService,
      private modalService: NgbModal, private router: Router,private route: ActivatedRoute,
      private spinnerService: SpinnerService,private toastNotifyService: ToastNotificationService,
      private inventoryService: InventoryService, private parentService: ParentService,private globalConstants: GlobalConstants,
      private tokenStorageService: TokenStorageService, private feeService: FeeService,private razorpayService: RazorpayService,
    ) { }

  ngOnInit() {
    console.log('--inside  FeeComponent- ngOnInit----');    
    this.showRefreshSpinner = false;
    this.countryList = environment.countryList;
    this.userRole = this.globalConstants.getUserRole();
    this.loggedinUser = this.globalConstants.getUserName();
    this.buildSearchForm();

    this.studentList = [];
    this.inventoryService.getStudentList(this.userRole, this.loggedinUser).subscribe(
      studentData => {
        this.studentList = studentData;
        console.log('this.studentList>>>>>> ',JSON.stringify(this.studentList))        
      },
      error => {
        console.log(error);        
      },
    );

    this.sessionList = [];
    this.parentService.getAcademicList().subscribe(
      res => {
        this.sessionList = res.data;
        console.log('this.sessionList>>>>>> ',JSON.stringify(this.sessionList))        
      },
      error => {
        console.log(error);        
      },
    );
  }
  private buildSearchForm() {
    this.searchForm = this.formBuilder.group({
      studentAdm: [null, Validators.required],
      academicYear: [this.tokenStorageService.getActiveSession(), Validators.required],
    });
  }
  getFeeList() {
    this.spinnerService.showSpinner();

    let studentAdm = this.searchForm.controls.studentAdm.value;
    let academicYear = this.searchForm.controls.academicYear.value;

    this.parentService.getfeeList(studentAdm,academicYear).subscribe(
      res => {
        if(environment.SUCCESS == res.status){
          this.feeList =  res.data;
          //this.toastNotifyService.showSuccess(res.message, "Notification");          
        }else if(environment.FAILURE == res.status){
          this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 10000);
        }  
        setTimeout(() => {
          this.spinnerService.hideSpinner();
        }, 200);      
      },
      error => {
        console.log(error);
        setTimeout(() => {
          this.spinnerService.hideSpinner();
        }, 200);
      },
    );
  }
  getPaymentHistoryModal(feeId: number){
    console.log('*****getPaymentHistory****',feeId); 
    this.feeService.getPaymentHistoryByFeeId(feeId).subscribe(
      paymentHistoryData => {
        console.log('>>>>>>>paymentHistoryData from service::', JSON.stringify(paymentHistoryData))
        this.modalRef = this.modalService.open(PaymentHistoryComponent, { windowClass : "modal-holder", centered: false, size: 'xl', backdrop:'static'});  
        this.modalRef.componentInstance.paymentHistory = paymentHistoryData.data;
        this.modalRef.componentInstance.modalRef = this.modalRef;
        
        this.modalRef.result.then(() => {
          console.log('****getPaymentHistoryModal- modalref then******');
          //this.router.navigate(['/user/task']); // works fine
          //this.getFeeList();
        }); 
    }); 
  }

  payNowModal(studentFeeId: number, balanceAmount: number){
    console.log('---------payNowModal--------------studentFeeId:'+studentFeeId)
    this.modalRef = this.modalService.open(PayAmountComponent, { windowClass : "modal-holder", centered: false, size: 'md', backdrop:'static'});  
    this.modalRef.componentInstance.studentFeeId = studentFeeId;
    this.modalRef.componentInstance.balanceAmount = balanceAmount;
    this.modalRef.componentInstance.modalRef = this.modalRef;
    
    this.modalRef.result.then(() => {
      console.log('****payNowModal- modalref then******');
      //this.router.navigate(['/user/task']); // works fine
      this.getFeeList();
    }); 
  }
  payNow(feeId: number){
    //if item stocks less during payment then checked & error message
    this.spinnerService.showSpinner();
    this.inventoryService.checkNGetOrderById(feeId).subscribe( //getOrderById
      res => {
        console.log('>>>>> Inventory order details:',JSON.stringify(res.data))
        if(environment.SUCCESS == res.status){
          const razorpayDto: RazorpayDto ={"amount": res.data.totalAmount,"currency":"INR"}
          this.razorpayService.createFeeOrder(razorpayDto).subscribe((razorOrder: any) => {
            console.log('>>>>>createOrder razorpay response :', JSON.stringify(razorOrder.data));
            this.razorpayService.payFeeWithRazor(razorOrder.data, res.data);
            //this.toastNotifyService.showSuccess('Payment Successful', "Notification");
          },
            err => {
              console.log('!!! Error from razorpay cretaedOrder:',err);    
              this.toastNotifyService.showErrorWithTimeout('Error & Payment Failure', "Notification", 7000);
              this.spinnerService.hideSpinner();     
            },
          );
        }else if(environment.FAILURE == res.status){
          this.toastNotifyService.showErrorWithTimeout(res.message, "Notification", 7000);
        }   
        this.spinnerService.hideSpinner();   
    },
      error => {
        console.log('!!! Error in  getOrderById:',error);    
        this.spinnerService.hideSpinner(); 
      },
    );
  }
  refreshFeeList(){
    this.showRefreshSpinner =  true;
    this.getFeeList();
    const urlTree = this.router.createUrlTree([], {
      queryParams: { size: environment.defaultPaginationSize, page: 1 },      
      queryParamsHandling: "merge",
      preserveFragment: true });  
    this.router.navigateByUrl(urlTree);

    this.showRefreshSpinner =  false;
  }
  
  getSelectedCountry(value: string){ 
    //console.log('----country value: ',this.addBoardForm.controls.boardId.value);// Prints only ID value
    //value prints as ==> 0: IN
  }
  resetSearchForm(){
    console.log('----resetting search form--------')
    this.searchForm.reset();
  }
}